import { atom } from 'recoil';
import * as T from '../types';

export const selectedSubFilterAtom = atom<T.GeoTypeKeys>({
  key: 'CORE-PROSPECT/GEOGRAPHY-PICKER/SELECTED-SUB-FILTER',
  default: 'MSA',
});
